module.exports = __webpack_public_path__ + "img/lock-screen.ceb9b5cf.webp";